import { Link, useLocation } from 'react-router-dom';
import { Button } from '../ui/button';

export function DesktopNav({ items }) {
  const location = useLocation();
  return (
    <nav className="hidden md:flex items-center gap-1">
      {items.map((item) => (
        <Link key={item.path} to={item.path}>
          <Button variant="ghost" size="sm"
            className={`text-xs gap-1.5 ${location.pathname === item.path ? 'bg-secondary text-foreground' : 'text-muted-foreground hover:text-foreground'}`}
            data-testid={`nav-${item.label.toLowerCase()}`}>
            <item.icon className="w-4 h-4" strokeWidth={1.5} />
            {item.label}
          </Button>
        </Link>
      ))}
    </nav>
  );
}

export function MobileNav({ items, onClose }) {
  const location = useLocation();
  return (
    <nav className="md:hidden border-t border-border p-2 bg-background animate-fade-in">
      {items.map((item) => (
        <Link key={item.path} to={item.path} onClick={onClose}>
          <Button variant="ghost"
            className={`w-full justify-start gap-2 text-sm ${location.pathname === item.path ? 'bg-secondary text-foreground' : 'text-muted-foreground'}`}>
            <item.icon className="w-4 h-4" strokeWidth={1.5} />
            {item.label}
          </Button>
        </Link>
      ))}
    </nav>
  );
}
